<template>
  <div>
    <h2 class="text-left border-bottom px-3 pt-2 pb-4 text-info">Save it to the Library</h2>

    <p class="py-1 px-3 lead" v-if="!isCompleted">Hello!<br>
Fantastic work that you have created re-usable content that you feel will add value to our global database. This action is irreversible, so please ensure you had your spell check on and proofed there are no grammatical errors - Thank you.
</p>

    <div class="container form-group kt-form kt-form--label-right mb-1 text-left save-it-template" v-if="!isCompleted">
      <div class="row mb-3 justify-content-center">
        <div class="col-9 validated">
          <BaseInputForm
            type="hidden"
            :disabled="true"
            v-model="$v.itineraryTemplate.code.$model"
            @blur="$v.itineraryTemplate.code.$touch()"
            :validator="$v.itineraryTemplate.code" />
          <!-- <BaseInputForm
            type="text"
            label="Code"
            placeholder="Generating code..."
            :isMandatory="true"
            :disabled="true"
            v-model="$v.itineraryTemplate.code.$model"
            @blur="$v.itineraryTemplate.code.$touch()"
            :validator="$v.itineraryTemplate.code" />
          <template v-if="$v.itineraryTemplate.code.$error">
            <div class="invalid-feedback" v-if="!$v.itineraryTemplate.code.required">
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                class="mr-1" /> Code is required.</div>
          </template> -->
        </div>
      </div>
      <!-- <div class="row mb-3 justify-content-center">
        <div class="col-9 validated">
          <BaseInputForm
            type="text"
            label="Title"
            placeholder=""
            :isMandatory="true"
            :disabled="isSaving"
            v-model="$v.itineraryTemplate.title.$model"
            @blur="$v.itineraryTemplate.title.$touch()"
            :validator="$v.itineraryTemplate.title" />
          <template v-if="$v.itineraryTemplate.title.$error">
            <div class="invalid-feedback" v-if="!$v.itineraryTemplate.title.required">
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                class="mr-1" /> Title is required.</div>
          </template>
        </div>
      </div> -->
      <div class="row mb-3 justify-content-center">
        <div class="col-9 validated">
          <BaseRadioButtonGroup
            label="Format"
            :options="customFormats"
            :isMandatory="true"
            :disabled="isSaving"
            v-model="$v.itineraryTemplate.format.$model"
            @blur="$v.itineraryTemplate.format.$touch()"
            :validator="$v.itineraryTemplate.format" />
          <template v-if="$v.itineraryTemplate.format.$error">
            <div class="invalid-feedback" v-if="!$v.itineraryTemplate.format.required">
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                class="mr-1" /> Format is required.</div>
          </template>
          <div
            class="format-description lead"
            :class="{
              'format-description--left': Number($v.itineraryTemplate.format.$model) === Number(customFormats[0].value),
              'format-description--center': Number($v.itineraryTemplate.format.$model) === Number(customFormats[1].value),
              'format-description--right': Number($v.itineraryTemplate.format.$model) === Number(customFormats[2].value),
            }">
            <!--Full itinerary original-->
            <span v-if="Number($v.itineraryTemplate.format.$model) === Number(customFormats[0].value)">
             Full itinerary would save the entire opportunity.
            </span>
            <span v-if="Number($v.itineraryTemplate.format.$model) === Number(customFormats[1].value)">
              Will file this day in Day by Day.
            </span>
            <span v-if="Number($v.itineraryTemplate.format.$model) === Number(customFormats[2].value)">
               Full Itinerary will file the entire itinerary and additionally Day by Day.
            </span>
          </div>
        </div>
      </div>
      <!-- <div class="row mb-3 justify-content-center">
        <div class="col-9 validated">
          <label class="labelTitle">Region <BaseRequiredField /></label>
        </div>
        <div class="col-9 validated">
          <Multiselect
            :options="regions"
            :disabled="isSaving"
            label="text"
            track-by="value"
            open-direction="bottom"
            :multiple="true"
            :taggable="true"
            :searchable="false"
            placeholder="Select a region"
            :loading="isLoading"
            v-model="$v.itineraryTemplate.region.$model" />
          <template v-if="$v.itineraryTemplate.region.$error">
            <div class="invalid-feedback" v-if="!$v.itineraryTemplate.region.required">
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                class="mr-1" /> Region is required.</div>
          </template>
        </div>
      </div> -->
      <!-- <div class="row mb-3 justify-content-center">
        <div class="col-9 validated">
          <BaseSelect
            label="Brand"
            :options="brands"
            :isMandatory="true"
            :disabled="isSaving"
            v-model="$v.itineraryTemplate.brand.$model"
            @blur="$v.itineraryTemplate.brand.$touch()"
            :validator="$v.itineraryTemplate.brand" />
          <template v-if="$v.itineraryTemplate.brand.$error">
            <div class="invalid-feedback" v-if="!$v.itineraryTemplate.brand.required">
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                class="mr-1" /> Brand is required.</div>
          </template>
        </div>
      </div> -->
      <div class="row mb-3 justify-content-center">
        <div class="col-9 validated">
          <BaseSelect
            label="Theme"
            :options="themes"
            :isMandatory="true"
            :disabled="isSaving"
            v-model="$v.itineraryTemplate.theme.$model"
            @blur="$v.itineraryTemplate.theme.$touch()"
            :validator="$v.itineraryTemplate.theme" />
          <template v-if="$v.itineraryTemplate.theme.$error">
            <div class="invalid-feedback" v-if="!$v.itineraryTemplate.theme.required">
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                class="mr-1" /> Theme is required.</div>
          </template>
        </div>
      </div>
      <div class="row mb-2 justify-content-center">
        <BaseButton
          type="button"
          classButton="btn btn-icon-box btn-primary btn-labeled mt-3"
          :disabled="isSaving"
          @click="save()">
          <span v-if="!isSaving">Save <span class="btn-label"><font-awesome-icon :icon="['fas', 'check']"/></span></span>
          <span v-if="isSaving">Generating template...<span class="btn-label"><font-awesome-icon :icon="['fas', 'spinner']" spin class="mr-1" /></span></span>
        </BaseButton>
      </div>
    </div>
    <div class="d-flex align-items-center flex-column message" v-if="isCompleted">
      <font-awesome-icon :icon="['fas', 'check']" size="8x" />
      <h2 style="display:none;" class="completed-title mt-2">{{ completedMessage }}</h2>
      <h2 class="completed-title mt-2">Saved successfully</h2>
      <p>Available in the Library in the next <u>24 hours</u>.</p>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import NProgress from 'nprogress'

// import Multiselect from 'vue-multiselect'

export default {
  name: 'SidebarSaveLikeATemplate',
  // components: { Multiselect },
  data () {
    return {
      isSaving: false,
      isLoading: false,
      isCompleted: false,
      completedMessage: '',
      itineraryTemplate: {
        code: '',
        format: '',
        theme: ''
      }
    }
  },
  validations: {
    itineraryTemplate: {
      code: { required },
      format: { required },
      theme: { required }
    }
  },
  mounted () {
    this.isLoading = true
    const defaultFormat = Number(this.customFormats[0].value)
    this.$v.itineraryTemplate.format.$model = defaultFormat
    this.$store.dispatch('itineraryTemplate/getNewTemplate')
      .then(response => {
        this.$v.itineraryTemplate.code.$model = response.data.code
        this.isLoading = false
      })
      .catch(error => {
        console.log(error)
        this.isLoading = false
      })
  },
  computed: {
    customFormats () {
      // Issue #293:
      // * Vamos a usar solo dos opciones "Day by Day" y "Both"
      // * Cambiar el nombre de Both por "Full Itinerary"
      // Issue #366:
      // Para esta tarea se tuvo que añadir nuevamente la opción Both
      // * 0 = Full itinerary, 1 = Day by day, 2 = Both
      return [
        { 'text': this.formats[0].text, 'value': this.formats[0].value },
        { 'text': this.formats[1].text, 'value': this.formats[1].value },
        { 'text': this.formats[2].text, 'value': this.formats[2].value }
      ]
    }
  },
  props: {
    opportunityData: {
      type: Object,
      required: true
    },
    selectedDay: {
      type: Object,
      required: true
    },
    formats: {
      type: Array,
      required: true
    },
    regions: {
      type: Array,
      required: true
    },
    brands: {
      type: Array,
      required: true
    },
    themes: {
      type: Array,
      required: true
    }
  },
  methods: {
    save () {
      // "touching" all fields to turn them "dirty"
      this.$v.$touch()

      // submit form only when all fields are valid
      if (!this.$v.$invalid) {
        NProgress.start()
        this.isSaving = true

        this.$emit('onSaveTemplate')

        const tpl = this.$v.itineraryTemplate.$model
        const opportunityData = this.opportunityData
        // Issue #366:
        // Para esta tarea se tuvo que añadir nuevamente la opción Both
        // * 0 = Full itinerary, 1 = Day by day, 2 = Both
        const FULL_ITINERARY = Number(this.customFormats[0].value)
        const DAY_BY_DAY = Number(this.customFormats[1].value)
        const BOTH = Number(this.customFormats[2].value)

        const code = tpl.code
        // const title = tpl.title
        const id = Number(opportunityData.itineraries[0].id)
        const brandId = Number(this.opportunityData.itineraries[0].brand_id)
        const itineraryFormatType = Number(tpl.format)
        const itineraryTheme = Number(tpl.theme)

        let days = []
        let regions = []
        // Issue #366:
        // Para esta tarea se tuvo que añadir nuevamente la opción Both
        // * 0 = Full itinerary, 1 = Day by day, 2 = Both

        if (Number(tpl.format) === FULL_ITINERARY) {
          if (opportunityData.itineraries[0].days.length > 0) {
            days = opportunityData.itineraries[0].days.map(d => ({ id: d.id }))
          }
        }

        if (Number(tpl.format) === DAY_BY_DAY) {
          if (opportunityData.itineraries[0].days.length > 0) {
            const dayId = this.selectedDay.data.id
            days = [{ id: dayId }]
          }
        }

        if (Number(tpl.format) === BOTH) {
          if (opportunityData.itineraries[0].days.length > 0) {
            days = opportunityData.itineraries[0].days.map(d => ({ id: d.id }))
          }
        }

        const payload = {
          itinerary_data: {
            code,
            itinerary: { id, days }
          },
          regions,
          brand_id: brandId,
          itinerary_format_type: itineraryFormatType,
          itinerary_theme: itineraryTheme
        }

        this.$store
          .dispatch('itineraryTemplate/addNewTemplate', payload)
          .then((response) => {
            // if (response.data.status === false) {
            if (response.data && response.data.status) {
              this.$notification.success(response.data.message, 10000)
              NProgress.done()
              this.isSaving = false
              this.isCompleted = true
              this.completedMessage = response.data.message
              this.$emit('onSaveTemplate')
            }
          })
          .catch(error => {
            console.log(error)
            this.$notification.error(error.response.data.message)
            NProgress.done()
            this.isSaving = false
            this.isCompleted = false
            this.completedMessage = ''
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.format-description {
  font-size: .8em;
  position: relative;
  background: #EDF1F7;
  padding: 1.5em 1em;
  margin-top: .5em;
  border-radius: 5px;
}

.format-description::before {
  position: absolute;
  content: '';
  display: block;
  width: 0;
  height: 0;
  top: -9px;
  border-right: 0.85rem solid transparent;
  border-bottom: calc(0.45rem * 1.732) solid #EDF1F7;
  border-left: 0.85rem solid transparent;
}

.format-description--left::before {
  left: calc(25% - 0.75rem);
}

.format-description--center::before {
  left: calc(50% - 0.75rem);
}

.format-description--right::before {
  left: calc(75% - 0.75rem);
}

.completed-title {
  font-size: 20px;
  font-weight: 500;
}
.save-it-template .switch-field label:first-child {
    border-right: 1px solid #e0e3ea;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    display: none;
}

.save-it-template .switch-field label:first-child {
    border-right: 1px solid #e0e3ea;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    display: none;
}
::v-deep .multiselect__tag {
  background: rgba(0, 167, 203, 0.15);
  color: #35495e;
}
::v-deep .multiselect__tag-icon {
  background: rgba(0, 167, 203, 0.15);
}

.lead {
  font-size: .9em;
  color: #032647;
}

.message {
  margin-top: 10rem;
}
</style>
